import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconCross, IconWarning, IconTick, IconInfo } from '@xingternal/icons';
import * as Styled from './status-banner.styles';
function getLeadIcon(variant) {
    switch (variant) {
        case 'success':
            return IconTick;
        case 'info':
            return IconInfo;
        default:
            return IconWarning;
    }
}
export const StatusBannerPrimitive = ({ children, closeButtonProps, display = 'fixed', handleOnClose, showCloseButton = true, variant, ...props }) => {
    const LeadIcon = getLeadIcon(variant);
    return (_jsxs(Styled.StatusBanner, { "$display": display, "$variant": variant, "data-xds": "StatusBanner", ...props, children: [_jsxs(Styled.Content, { children: [_jsx(Styled.Icon, { children: _jsx(LeadIcon, {}) }), _jsx(Styled.Text, { size: "small", children: children })] }), handleOnClose && showCloseButton ? (_jsx(Styled.Close, { "$variant": variant, "data-qa": "close", "data-testid": "close", icon: IconCross, onClick: handleOnClose, size: "medium", ...closeButtonProps })) : null] }));
};
StatusBannerPrimitive.displayName = 'StatusBanner (Primitive)';
//# sourceMappingURL=status-banner.primitive.js.map